/**
 * @Author: Li, Yu Jia
 * @Date: 2020-03-21 15:14:16
 * @Last Modified by: Li, Yu Jia
 * @Last Modified time: 2020-04-09 13:37:23
 */

import * as mainSelectors from './../../selectors';

import MessageBox from './../MessageBox';
import PropTypes from 'prop-types';
import React from 'react';
import { TOKEN_EXPIRATION_CAPTION } from './../../../utils/constants';
import { messageBoxButtons } from './../../constants';
import { useSelector } from 'react-redux';

const TokenExpiration = (props) => {
  const { onOkClick } = props;
  const showTokenExpiration = useSelector(mainSelectors.getTokenExpirationShow);
  const okHandler = () => {
    onOkClick();
  };
  return (
    <>
      <MessageBox
        show={showTokenExpiration}
        buttons={messageBoxButtons.ok}
        onOk={okHandler}
        onCancel={() => {}}
        onClose={() => {}}
        text={TOKEN_EXPIRATION_CAPTION}
      />
    </>
  );
};

TokenExpiration.propTypes = {
  onOkClick: PropTypes.func.isRequired,
};

export default TokenExpiration;
